if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false
        this.form.addEventListener('submit', this.checkForDynamicDimensions.bind(this))
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.extraOptionalTools = document.querySelectorAll('optional-tools .kit-list')
        this.extraOptionalItems = document.querySelectorAll('optional-items')
        this.stepExtraProducts = document.querySelectorAll('step-extra-product')
        this.roomixDimensions = document.querySelector('roomix-dimensions')
        this.summaryExtras = document.querySelector('roomix-design-tool-summary');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      checkForDynamicDimensions(evt) {
        evt.preventDefault();
        if (document.querySelector('roomix-dimensions') && document.querySelector('roomix-dimensions').dataset.variantId === 'pending') {
          document.querySelector('roomix-dimensions').createProduct();
        } else {
          this.onSubmitHandler(evt)
        }
      }

      createHiddenFormInputProperty = (value, bundleId) => {
        const hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = value;
        hiddenInput.value = bundleId;
        let productIdElement = this.form.querySelector('[name="product-id"]');
        this.form.insertBefore(hiddenInput, productIdElement);
      }
      compileProductLocator() {
        // get all the data-id-locator locators and create a number to include on the property
        let locators = document.querySelectorAll('[data-id-locator]:checked');
        let locatorString = '';
        locators.forEach((item, index) => {
          locatorString += item.getAttribute('data-id-locator');
        })
        return locatorString;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner')?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const is_upselling = this.submitButton.classList.contains('button-upselling')
        const no_cart = this.submitButton.classList.contains('no-cart')

        let bundleNumber = Math.floor(9e4 * Math.random()) + 1e4;
        this.createHiddenFormInputProperty('properties[_bundle]', bundleNumber);
        this.createHiddenFormInputProperty('properties[_product_locator]', this.compileProductLocator());

        const deliverCalendar = document.querySelector('delivery-calendar')
        if (deliverCalendar && deliverCalendar.dataset.deliveryOnOrder === 'true') {
          this.createHiddenFormInputProperty('properties[_deliveryDate]', deliverCalendar.querySelector('input').value);
          this.createHiddenFormInputProperty('properties[Delivery Date]', document.querySelector('.summary-step.delivery-summary span').innerText);
        }

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        if (!this.submitButton.classList.contains('quick-add__submit') && (this.extraOptionalTools || (this.extraOptionalItems && this.extraOptionalItems.length > 0))) {
          let connectedTools = [];
          let notConnectedTools = [];

          if (this.extraOptionalTools && this.extraOptionalTools.length > 0) {
            this.extraOptionalTools.forEach(toolList => {
              const isBundle = toolList.closest('optional-tools')?.classList.contains('mode-bundle');
              const isAddon = toolList.closest('optional-tools')?.classList.contains('mode-addon');

              toolList.querySelectorAll('input:checked').forEach(input => {
                if (isBundle || isAddon) {
                  notConnectedTools.push(input);
                } else {
                  connectedTools.push(input);
                }
              });
            });
          }
          let summaryExtras = this.summaryExtras?.querySelectorAll('input:checked');
          let productsID = []
          let notConnectedIDs = []
          let mainVariant = this.form.querySelector('[name="id"]').value;

          productsID.push(mainVariant)

          if (summaryExtras) {
            summaryExtras.forEach( input => {
              productsID.push(input.dataset.variant);
            })
          }

          if (connectedTools) {
            connectedTools.forEach(input => {
              productsID.push(input.dataset.variant)
            })
          }
          if (notConnectedTools) {
            notConnectedTools.forEach(input => {
              notConnectedIDs.push(input.dataset.variant)
            })
          }

          let product_data = productsID.map((variantId, index) => {
            let properties = {};
            let quantity = 1
            if (this.roomixDimensions) {
              quantity = Number(this.roomixDimensions.querySelector('quantity-input input').value)
            }

            // Variant Matrix quantity input
            let variantSelectsMatrix = document.querySelector('variant-selects-matrix');
            if (variantSelectsMatrix) {
              let quantityInput = variantSelectsMatrix.closest('.step-content').querySelector('quantity-input input')
              if (quantityInput) {
                quantity = Number(quantityInput.value)
              }
            }

            if (index === 0) {
              if (connectedTools && connectedTools.length > 0) {
                properties = {
                  _bundle: bundleNumber,
                  _MainBundle: true,
                  _NumberOfTools: connectedTools.length
                }

                if (this.roomixDimensions) {
                  quantity = Number(this.roomixDimensions.querySelector('quantity-input input').value)
                }
              } else {
                properties = {
                  _bundle: bundleNumber,
                  _MainBundle: true
                }
              }
              if (this.form.querySelectorAll('[name^="properties"]').length > 0) {
                this.form.querySelectorAll('[name^="properties"]').forEach((item, index) => {
                  let propertyName = item.attributes.name.value.split('[')[1].split(']')[0];
                  properties[propertyName] = item.value;
                });
              }
            } else {
              quantity = 1
              properties = {
                _bundle: bundleNumber,
                _tool: true,
                _variantId: variantId
              }
            }
            if (mainVariant === variantId) {
              return {quantity: quantity, id: Number(variantId), properties: properties}
            } else {
              return {quantity: quantity, parent_id: mainVariant, id: Number(variantId), properties: properties}
            }

          })

          if (this.extraOptionalItems) {
            if (is_upselling === false) {
              this.extraOptionalItems.forEach(element => {
                let extraItem = element.querySelector('input:checked')
                if (extraItem && (extraItem.dataset.price > 0 || extraItem.dataset.forceCart === 'true')) {
                  let quantity = 1;
                  let quantityInput = element.querySelector('quantity-input input')
                  if (quantityInput) {
                    quantity = Number(quantityInput.value)
                  }
                  product_data.push({
                    quantity: quantity,
                    parent_id: mainVariant,
                    id: Number(extraItem.dataset.variant),
                    properties: {_bundle: bundleNumber, _paint: true}
                  })
                }
              })
            }
          }
          if (this.stepExtraProducts) {
            this.stepExtraProducts.forEach(element => {
              let extraItem = element.querySelector('input:checked')
              let properties = {_bundle: bundleNumber};
              if (extraItem && element.dataset.property) {
                properties[element.dataset.property] = true;
              }
              if (extraItem && extraItem.dataset.variantPrice > 0) {
                let quantity = element.dataset.quantity;
                product_data.push({
                  quantity: quantity,
                  parent_id: mainVariant,
                  id: Number(extraItem.dataset.variant),
                  properties: properties
                })
              }
            })
          }

          notConnectedIDs.forEach(variantId => {
            product_data.push({
              quantity: 1,
              id: Number(variantId),
              properties: { _bundle: bundleNumber }
            });
          });

          if (notConnectedTools) {
            product_data.reverse()
          }

          let data = {
            items: product_data,
            sections: this.cart.getSectionsToRender().map(section => section.id),
            sections_url: window.location.pathname
          }

          if (document.body.classList.contains('template--product-design-product-new')) {
            data.note = this._getPanellingDesignUrl();
          }

          config.body = JSON.stringify(data)
          config.headers['Content-Type'] = 'application/json'
        } else {
          config.body = formData;
        }

        fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButtonText.classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            }).then(() => {
              CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
            });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  CartPerformance.measure("add:paint-updated-sections", () => {
                    this.cart.renderContents(response);
                  });
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            CartPerformance.measure("add:paint-updated-sections", () => {
              this.cart.renderContents(response);
            });
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner')?.classList.add('hidden');

          CartPerformance.measureFromEvent("add:user-action", evt);
        });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      _getUrlParameter(name) {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
        var results = regex.exec(location.search);
        return results === null
          ? ""
          : decodeURIComponent(results[1].replace(/\+/g, " "));
      }

      _getPanellingDesignUrl() {
        const currentDomain = window.location.hostname;
        const currentProtocol = window.location.protocol;
        const path = '/pages/design-tool';
        let params = '?width=' + this._getUrlParameter("width");
        params += '&height=' + this._getUrlParameter("height");
        params += '&rows=' + this._getUrlParameter("rows");
        params += '&columns=' + this._getUrlParameter("columns");
        params += '&panel-height=' + ((parseInt(this._getUrlParameter("panel-height")) + 20) / 100);
        params += '&paint=' + this._getUrlParameter("paint");
        params += '&modal=0';
        return `${currentProtocol}//${currentDomain}${path}${params}`;
      }
    }
  );
}
